"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFileSource = void 0;

var fs_1 = __importDefault(require("fs"));

var basesource_js_1 = require("./basesource.js");

function closeAsync(fd) {
  return new Promise(function (resolve, reject) {
    fs_1.default.close(fd, function (err) {
      if (err) {
        reject(err);
      } else {
        resolve();
      }
    });
  });
}

function openAsync(path, flags) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    fs_1.default.open(path, flags, mode, function (err, fd) {
      if (err) {
        reject(err);
      } else {
        resolve(fd);
      }
    });
  });
}

function readAsync() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new Promise(function (resolve, reject) {
    var _fs_1$default;

    (_fs_1$default = fs_1.default).read.apply(_fs_1$default, args.concat([function (err, bytesRead, buffer) {
      if (err) {
        reject(err);
      } else {
        resolve({
          bytesRead: bytesRead,
          buffer: buffer
        });
      }
    }]));
  });
}

var FileSource = /*#__PURE__*/function (_basesource_js_1$Base) {
  (0, _inherits2.default)(FileSource, _basesource_js_1$Base);

  var _super = _createSuper(FileSource);

  function FileSource(path) {
    var _this;

    (0, _classCallCheck2.default)(this, FileSource);
    _this = _super.call(this);
    _this.path = path;
    _this.openRequest = openAsync(path, 'r');
    return _this;
  }

  (0, _createClass2.default)(FileSource, [{
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(slice) {
        var fd, _yield$readAsync, buffer;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.openRequest;

              case 2:
                fd = _context.sent;
                _context.next = 5;
                return readAsync(fd, Buffer.alloc(slice.length), 0, slice.length, slice.offset);

              case 5:
                _yield$readAsync = _context.sent;
                buffer = _yield$readAsync.buffer;
                return _context.abrupt("return", buffer.buffer);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchSlice(_x) {
        return _fetchSlice.apply(this, arguments);
      }

      return fetchSlice;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var fd;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.openRequest;

              case 2:
                fd = _context2.sent;
                _context2.next = 5;
                return closeAsync(fd);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }]);
  return FileSource;
}(basesource_js_1.BaseSource);

function makeFileSource(path) {
  return new FileSource(path);
}

exports.makeFileSource = makeFileSource;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUEsU0FBU0EsVUFBVCxDQUFvQkMsRUFBcEIsRUFBc0I7RUFDcEIsT0FBTyxJQUFJQyxPQUFKLENBQVksVUFBQ0MsT0FBRCxFQUFVQyxNQUFWLEVBQW9CO0lBQ3JDQyxhQUFHQyxLQUFILENBQVNMLEVBQVQsRUFBYSxVQUFDTSxHQUFELEVBQVE7TUFDbkIsSUFBSUEsR0FBSixFQUFTO1FBQ1BILE1BQU0sQ0FBQ0csR0FBRCxDQUFOO01BQ0QsQ0FGRCxNQUVPO1FBQ0xKLE9BQU87TUFDUjtJQUNGLENBTkQ7RUFPRCxDQVJNLENBQVA7QUFTRDs7QUFFRCxTQUFTSyxTQUFULENBQW1CQyxJQUFuQixFQUF5QkMsS0FBekIsRUFBZ0Q7RUFBQSxJQUFoQkMsSUFBZ0IsdUVBQVRDLFNBQVM7RUFDOUMsT0FBTyxJQUFJVixPQUFKLENBQVksVUFBQ0MsT0FBRCxFQUFVQyxNQUFWLEVBQW9CO0lBQ3JDQyxhQUFHUSxJQUFILENBQVFKLElBQVIsRUFBY0MsS0FBZCxFQUFxQkMsSUFBckIsRUFBMkIsVUFBQ0osR0FBRCxFQUFNTixFQUFOLEVBQVk7TUFDckMsSUFBSU0sR0FBSixFQUFTO1FBQ1BILE1BQU0sQ0FBQ0csR0FBRCxDQUFOO01BQ0QsQ0FGRCxNQUVPO1FBQ0xKLE9BQU8sQ0FBQ0YsRUFBRCxDQUFQO01BQ0Q7SUFDRixDQU5EO0VBT0QsQ0FSTSxDQUFQO0FBU0Q7O0FBRUQsU0FBU2EsU0FBVCxHQUEwQjtFQUFBLGtDQUFKQyxJQUFJO0lBQUpBLElBQUk7RUFBQTs7RUFDeEIsT0FBTyxJQUFJYixPQUFKLENBQVksVUFBQ0MsT0FBRCxFQUFVQyxNQUFWLEVBQW9CO0lBQUE7O0lBQ3JDLCtCQUFHWSxJQUFILHNCQUFXRCxJQUFYLFNBQWlCLFVBQUNSLEdBQUQsRUFBTVUsU0FBTixFQUFpQkMsTUFBakIsRUFBMkI7TUFDMUMsSUFBSVgsR0FBSixFQUFTO1FBQ1BILE1BQU0sQ0FBQ0csR0FBRCxDQUFOO01BQ0QsQ0FGRCxNQUVPO1FBQ0xKLE9BQU8sQ0FBQztVQUFFYyxTQUFTLEVBQVRBLFNBQUY7VUFBYUMsTUFBTSxFQUFOQTtRQUFiLENBQUQsQ0FBUDtNQUNEO0lBQ0YsQ0FORDtFQU9ELENBUk0sQ0FBUDtBQVNEOztJQUVLQyxVOzs7OztFQUNKLG9CQUFZVixJQUFaLEVBQWdCO0lBQUE7O0lBQUE7SUFDZDtJQUNBLE1BQUtBLElBQUwsR0FBWUEsSUFBWjtJQUNBLE1BQUtXLFdBQUwsR0FBbUJaLFNBQVMsQ0FBQ0MsSUFBRCxFQUFPLEdBQVAsQ0FBNUI7SUFIYztFQUlmOzs7OztnR0FFRCxpQkFBaUJZLEtBQWpCO1FBQUE7O1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUE7Z0JBQUEsT0FFbUIsS0FBS0QsV0FGeEI7O2NBQUE7Z0JBRVFuQixFQUZSO2dCQUFBO2dCQUFBLE9BRzJCYSxTQUFTLENBQ2hDYixFQURnQyxFQUVoQ3FCLE1BQU0sQ0FBQ0MsS0FBUCxDQUFhRixLQUFLLENBQUNHLE1BQW5CLENBRmdDLEVBR2hDLENBSGdDLEVBSWhDSCxLQUFLLENBQUNHLE1BSjBCLEVBS2hDSCxLQUFLLENBQUNJLE1BTDBCLENBSHBDOztjQUFBO2dCQUFBO2dCQUdVUCxNQUhWLG9CQUdVQSxNQUhWO2dCQUFBLGlDQVVTQSxNQUFNLENBQUNBLE1BVmhCOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7OzsyRkFhQTtRQUFBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUE7Z0JBQUEsT0FDbUIsS0FBS0UsV0FEeEI7O2NBQUE7Z0JBQ1FuQixFQURSO2dCQUFBO2dCQUFBLE9BRVFELFVBQVUsQ0FBQ0MsRUFBRCxDQUZsQjs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7OztFQXBCdUJ5QiwwQjs7QUEwQnpCLFNBQWdCQyxjQUFoQixDQUErQmxCLElBQS9CLEVBQW1DO0VBQ2pDLE9BQU8sSUFBSVUsVUFBSixDQUFlVixJQUFmLENBQVA7QUFDRDs7QUFGRG1CIiwibmFtZXMiOlsiY2xvc2VBc3luYyIsImZkIiwiUHJvbWlzZSIsInJlc29sdmUiLCJyZWplY3QiLCJmc18xIiwiY2xvc2UiLCJlcnIiLCJvcGVuQXN5bmMiLCJwYXRoIiwiZmxhZ3MiLCJtb2RlIiwidW5kZWZpbmVkIiwib3BlbiIsInJlYWRBc3luYyIsImFyZ3MiLCJyZWFkIiwiYnl0ZXNSZWFkIiwiYnVmZmVyIiwiRmlsZVNvdXJjZSIsIm9wZW5SZXF1ZXN0Iiwic2xpY2UiLCJCdWZmZXIiLCJhbGxvYyIsImxlbmd0aCIsIm9mZnNldCIsImJhc2Vzb3VyY2VfanNfMSIsIm1ha2VGaWxlU291cmNlIiwiZXhwb3J0cyJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9kaXN0LW1vZHVsZS9zb3VyY2UvZmlsZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==